<div class="card-metric">
  <div class="value" [style.color]="color">
    <ng-container *ngIf="!loading">{{ value }}</ng-container>
    <ngx-skeleton-loader *ngIf="loading"></ngx-skeleton-loader>
  </div>
  <div class="label">{{ label }}</div>
  <div class="description">{{ description }}</div>
  <mat-icon class="icon" [style.color]="color" [style.background-color]="backgroundColor" *ngIf="icon">
    {{ icon }}
  </mat-icon>
</div>
